module.exports = "/_next/static/images/logo-5-c7ac05af205761d36abfbd6cfa549985.svg";